import { QueryClient } from "@tanstack/react-query";
import { api } from "../../convex/_generated/api";
import { OptimisticLocalStore } from "convex/browser";
import { convexQuery } from "@convex-dev/react-query";

/**
 * Gets the current value for a query from either the localStore or queryClient
 */
export function getTasks(
  convexLocalStore: OptimisticLocalStore,
  queryClient: QueryClient
) {
  let currentValue = convexLocalStore.getQuery(api.tasks.get, {});
  if (!navigator.onLine || !currentValue?.length) {
    currentValue = queryClient.getQueryData(
      convexQuery(api.tasks.get, {}).queryKey
    );
  }
  return currentValue;
}
